import { SET_REQUESTS, SET_LOADING_REQUESTS } from '../actions/actions';
import produce from 'immer';

const INITIAL_STATE = {
  openRequestsCount: 0,
  loading: true
};

export default function jobsReducer(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case SET_REQUESTS: {
        draft.openRequestsCount = action.payload;
        draft.loading = false;
        break;
      }
      case SET_LOADING_REQUESTS: {
        draft.loading = true;
        break;
      }
      default:
        return state;
    }
  });
}
